import { SET_FILTER_STATE, } from "./itemContainer.actions";

export enum ProductCategoryType {
    FOOD = "FOOD",
    DRINK = "DRINK"
}

export enum EnabledDisabledStatus {
    ENABLED = "ENABLED",
    DISABLED = "DISABLED"
}

export interface ISubcategoryListState {
    filterState: { MainCategoryFilter: ProductCategoryType[], SubcategoryStatusEnabled: EnabledDisabledStatus[]; };
}

export const subcategoryListInitalState: ISubcategoryListState = {
    filterState: { MainCategoryFilter: [], SubcategoryStatusEnabled: [] }
};

export function subcategoryListReducer(state: ISubcategoryListState, action: { type: string, payload: { MainCategoryFilter: ProductCategoryType[], SubcategoryStatusEnabled: EnabledDisabledStatus[]; }; }) {
    switch (action.type) {
        case SET_FILTER_STATE:
            return {
                ...state,
                filterState: action.payload
            };
        default:
            return state;
    }
}